export const vendorRegistrationFormDefaults = {
  companyName: "PT. Example Company",
  contactPerson: "",
  companyEmail: "email@company.com",
  companyPhone: "+62 812 3456 7890",
  quotationFileName: "",
  qualificationFileName: "",
};

export const internalCreateTenderFormDefaults = {
  title: "",
  description: "",
  categoryId: "",
  jenisId: "",
  budget: "5000000000",
  deadline: "",
  ursFileName: "",
};

export const entitiesSeed = {
  notifications: [
    { id: "NTF-001", title: "Deadline tender TDR-002 mendekati batas", type: "warning", time: "5 menit lalu" },
    { id: "NTF-002", title: "Vendor baru mendaftar pada TDR-001", type: "info", time: "18 menit lalu" },
    { id: "NTF-003", title: "Audit trail mencatat perubahan budget", type: "success", time: "47 menit lalu" },
  ],
  tenderCategories: [
    { id: "CAT-001", title: "IT Infrastructure", active: true },
    { id: "CAT-002", title: "Consulting", active: true },
    { id: "CAT-003", title: "Operational Services", active: true },
  ],
  tenderTypes: [
    { id: "JNS-001", title: "Tender Terbuka", active: true },
    { id: "JNS-002", title: "Tender Terbatas", active: true },
    { id: "JNS-003", title: "Penunjukan Langsung", active: true },
  ],
  progressTender: [
    { id: "PRG-001", title: "Evaluasi Teknis", status: "over", tanggal: "2026-02-08", active: true },
    { id: "PRG-002", title: "Registrasi Vendor", status: "deadline", tanggal: "2026-02-17", active: true },
    { id: "PRG-003", title: "Award", status: "early", tanggal: "2026-02-28", active: true },
  ],
  tenders: [
    {
      id: "TDR-001",
      tenderCode: "TND-000001",
      title: "Pengadaan Server Data Center",
      description: "Tender pengadaan server core data center untuk kebutuhan komputasi dan storage.",
      ursDocument: "URS_Server_DataCenter_2026.pdf",
      budget: 5000000000,
      deadline: "2026-02-15",
      categoryId: "CAT-001",
      jenisId: "JNS-001",
      vendorId: "VND-001",
      status: "aktif",
      progressId: "PRG-001",
    },
    {
      id: "TDR-002",
      tenderCode: "TND-000002",
      title: "Jasa Konsultan Manajemen",
      description:
        "Tender jasa konsultan untuk transformasi digital perusahaan. Meliputi assessment kondisi current, roadmap digitalisasi, dan pendampingan implementasi selama 12 bulan.",
      ursDocument: "URS_Konsultan_Digital.pdf",
      budget: 2200000000,
      deadline: "2026-02-28",
      categoryId: "CAT-002",
      jenisId: "JNS-002",
      vendorId: "VND-002",
      status: "aktif",
      progressId: "PRG-002",
    },
  ],
  vendorDashboard: {
    notifications: [
      { id: "NTF-001", title: "Deadline tender TDR-002 mendekati batas", type: "warning", time: "5 menit lalu" },
      { id: "NTF-002", title: "Vendor baru mendaftar pada TDR-001", type: "info", time: "18 menit lalu" },
      { id: "NTF-003", title: "Audit trail mencatat perubahan budget", type: "success", time: "47 menit lalu" },
    ],
    kpiCards: [
      { id: "KPI-001", title: "Tender Diikuti", value: "2", subtitle: "Tender aktif saat ini", icon: "file" },
      { id: "KPI-002", title: "Menunggu Hasil", value: "1", subtitle: "Masuk tahap evaluasi", icon: "clock" },
      { id: "KPI-003", title: "Tender Dimenangkan", value: "5", subtitle: "Rekap tahun berjalan", icon: "award" },
      { id: "KPI-004", title: "Tingkat Sukses", value: "45%", subtitle: "5 dari 11 tender", icon: "check" },
    ],
    dashboardTabs: [
      { id: "TAB-001", label: "Tersedia", count: 1 },
      { id: "TAB-002", label: "Diikuti", count: 2 },
      { id: "TAB-003", label: "Dimenangkan", count: 5 },
    ],
    focusTender: {
      id: "TND-000002",
      title: "Jasa Konsultan Manajemen",
      badge: "Registrasi Vendor",
      description:
        "Tender jasa konsultan untuk transformasi digital perusahaan. Meliputi assessment kondisi current, roadmap digitalisasi, dan pendampingan implementasi selama 12 bulan.",
      dueDate: "28 Februari 2026",
      vendorCount: 12,
      category: "Consulting",
      tenderType: "Tender Terbatas",
      slaAlert: "SLA Terlewat! Target 17/02 sudah terlewat 64 hari",
      ursFile: {
        name: "URS_Konsultan_Digital.pdf",
        size: "1.8 MB",
        uploadedAt: "Uploaded 5 Januari 2026",
      },
      timeline: [
        { id: "TL-001", title: "Tender Dibuat", date: "5 Januari 2026", tone: "green" },
        { id: "TL-002", title: "Terakhir Diupdate", date: "13 Januari 2026", tone: "green" },
        { id: "TL-003", title: "Deadline", date: "28 Februari 2026", tone: "yellow" },
      ],
    },
    tenderStages: [
      { step: 1, title: "Draft", date: "14/02", state: "done" },
      { step: 2, title: "Undang", date: "14/02", state: "done" },
      { step: 3, title: "Regis", date: "17/02", state: "current" },
      { step: 4, title: "Dok", date: "18/02", state: "pending" },
      { step: 5, title: "Aanwij", date: "19/02", state: "pending" },
      { step: 6, title: "DL", date: "20/02", state: "pending" },
      { step: 7, title: "Ev.Tek", date: "21/02", state: "pending" },
      { step: 8, title: "Klari", date: "22/02", state: "pending" },
      { step: 9, title: "Ev.Hrg", date: "23/02", state: "pending" },
      { step: 10, title: "Lap", date: "24/02", state: "pending" },
      { step: 11, title: "Tetap", date: "27/02", state: "pending" },
      { step: 12, title: "Award", date: "28/02", state: "pending" },
      { step: 13, title: "Kontrak", date: "-", state: "pending" },
      { step: 14, title: "PO", date: "-", state: "pending" },
      { step: 15, title: "Closed", date: "-", state: "pending" },
    ],
    offerStatus: [
      { id: "OFS-001", title: "Pengadaan Server Data Center", done: 7, total: 15 },
      { id: "OFS-002", title: "Sistem ERP Enterprise", done: 8, total: 15 },
    ],
    actionItems: [
      {
        id: "ACT-001",
        title: "Upload Dokumen Penawaran",
        detail: "Tender Server DC menunggu dokumen penawaran Anda",
        due: "Due today",
        priority: "Urgent",
      },
      {
        id: "ACT-002",
        title: "Lengkapi Dokumen Kualifikasi",
        detail: "Kelengkapan legalitas vendor belum lengkap",
        due: "1 hari lagi",
        priority: "High",
      },
    ],
  },
  internalDashboard: {
    notifications: [
      { id: "INT-NTF-001", title: "Approval dokumen vendor menunggu", type: "warning", time: "6 menit lalu" },
      { id: "INT-NTF-002", title: "Tender baru dibuat oleh Procurement", type: "info", time: "22 menit lalu" },
      { id: "INT-NTF-003", title: "Role switched to vendor view", type: "success", time: "1 jam lalu" },
    ],
    kpiCards: [
      { id: "IKPI-001", title: "Tender Aktif", value: "4", subtitle: "↑ 12%", icon: "file", trendTone: "up" },
      { id: "IKPI-002", title: "Vendor Terdaftar", value: "46", subtitle: "↑ 8%", icon: "users", trendTone: "up" },
      { id: "IKPI-003", title: "Menunggu Approval", value: "3", subtitle: "", icon: "clock", trendTone: "neutral" },
      { id: "IKPI-004", title: "Total Anggaran", value: "Rp 37.7M", subtitle: "Tender aktif", icon: "trend-up", trendTone: "neutral" },
    ],
    tabs: [
      { id: "ITAB-001", label: "Aktif", count: 7 },
      { id: "ITAB-002", label: "Evaluasi", count: 3 },
      { id: "ITAB-003", label: "Selesai", count: 14 },
    ],
    focusTender: {
      id: "TND-000001",
      title: "Pengadaan Server Data Center",
      badge: "Evaluasi Teknis",
      description:
        "Tender pengadaan server data center untuk peningkatan performa sistem inti perusahaan, termasuk storage, backup, dan high availability cluster.",
      dueDate: "15 Feb 2026",
      vendorCount: 8,
      category: "IT Infrastructure",
      tenderType: "Tender Terbatas",
      slaAlert: "SLA Terlewat! Target 17/02 sudah terlewat 64 hari",
      budgetDisplay: "Rp 5.000.000.000",
      ursFile: {
        name: "URS_Server_DataCenter_2026.pdf",
        size: "2.5 MB",
        uploadedAt: "Uploaded 1 Januari 2026",
      },
      timeline: [
        { id: "INT-TL-001", title: "Tender Dibuat", date: "5 Januari 2026", tone: "green" },
        { id: "INT-TL-002", title: "Terakhir Diupdate", date: "13 Januari 2026", tone: "green" },
        { id: "INT-TL-003", title: "Deadline", date: "15 Februari 2026", tone: "yellow" },
      ],
    },
    tenderStages: [
      { step: 1, title: "Dok" },
      { step: 2, title: "Aanwij" },
      { step: 3, title: "DL" },
      { step: 4, title: "Evaluasi Teknis" },
      { step: 5, title: "Klari" },
      { step: 6, title: "Ev.Hrg" },
      { step: 7, title: "Lap" },
      { step: 8, title: "Nego" },
      { step: 9, title: "Award" },
      { step: 10, title: "Kontrak" },
      { step: 11, title: "PO" },
      { step: 12, title: "Closed" },
      { step: 13, title: "Handover" },
      { step: 14, title: "BAST" },
      { step: 15, title: "Selesai" },
    ],
    currentStep: 3,
    actionItems: [
      {
        id: "I-ACT-001",
        title: "Evaluasi Proposal Server DC",
        detail: "8 proposal vendor menunggu evaluasi teknis",
        due: "Due today",
        priority: "Urgent",
      },
      {
        id: "I-ACT-002",
        title: "Approval Vendor Baru",
        detail: "2 vendor baru menunggu verifikasi dokumen",
        due: "Due today",
        priority: "Medium",
      },
    ],
    auditTrail: [
      { id: "ADT-001", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "09.36", tone: "blue" },
      { id: "ADT-002", event: "ROLE_SWITCH", note: "Switched to vendor view", time: "09.36", tone: "blue" },
      { id: "ADT-003", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "09.36", tone: "green" },
      { id: "ADT-004", event: "ROLE_SWITCH", note: "Switched to vendor view", time: "09.36", tone: "blue" },
      { id: "ADT-005", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "08.56", tone: "green" },
      { id: "ADT-003", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "09.36", tone: "green" },
      { id: "ADT-004", event: "ROLE_SWITCH", note: "Switched to vendor view", time: "09.36", tone: "blue" },
      { id: "ADT-005", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "08.56", tone: "green" },
      { id: "ADT-003", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "09.36", tone: "green" },
      { id: "ADT-004", event: "ROLE_SWITCH", note: "Switched to vendor view", time: "09.36", tone: "blue" },
      { id: "ADT-005", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "08.56", tone: "green" },
      { id: "ADT-003", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "09.36", tone: "green" },
      { id: "ADT-004", event: "ROLE_SWITCH", note: "Switched to vendor view", time: "09.36", tone: "blue" },
      { id: "ADT-005", event: "ROLE_SWITCH", note: "Switched to procurement view", time: "08.56", tone: "green" },
    ],
    registeredVendors: [
      {
        id: "IVND-001",
        companyName: "PT Teknologi Maju",
        email: "info@teknologimaju.co.id",
        contactPerson: "Rina Putri",
        phone: "+62 811 2345 6789",
        registrationDate: "10 Januari 2026",
        documentCount: 4,
        status: "approved",
        documents: [
          { id: "DOC-001", name: "Company_Profile.pdf", subtitle: "Profil Perusahaan", date: "10 Januari 2026" },
          { id: "DOC-002", name: "SIUP.pdf", subtitle: "Dokumen Legal", date: "10 Januari 2026" },
          { id: "DOC-003", name: "NPWP.pdf", subtitle: "Dokumen Pajak", date: "10 Januari 2026" },
          { id: "DOC-004", name: "Financial_Report.pdf", subtitle: "Laporan Keuangan", date: "10 Januari 2026" },
        ],
      },
      {
        id: "IVND-002",
        companyName: "CV Solusi Digital",
        email: "contact@solusidigital.com",
        contactPerson: "Andi Wijaya",
        phone: "+62 821 9876 5432",
        registrationDate: "13 Januari 2026",
        documentCount: 3,
        status: "pending",
        documents: [
          { id: "DOC-005", name: "Company_Profile.pdf", subtitle: "Profil Perusahaan", date: "13 Januari 2026" },
          { id: "DOC-006", name: "Akta_CV.pdf", subtitle: "Dokumen Legal", date: "13 Januari 2026" },
          { id: "DOC-007", name: "Technical_Proposal.pdf", subtitle: "Proposal Teknis", date: "13 Januari 2026" },
        ],
      },
      {
        id: "IVND-003",
        companyName: "PT Auto Prima",
        email: "sales@autoprima.co.id",
        contactPerson: "Budi Santoso",
        phone: "+62 813 9876 5432",
        registrationDate: "12 Januari 2026",
        documentCount: 2,
        status: "rejected",
        documents: [
          { id: "DOC-008", name: "Company_Profile.pdf", subtitle: "Profil Perusahaan", date: "12 Januari 2026" },
          { id: "DOC-009", name: "Legal_Documents.pdf", subtitle: "Dokumen Legal", date: "12 Januari 2026" },
        ],
      },
    ],
    updateProgress: {
      currentStatus: "DL",
      slaWarning: "Peringatan: Tahap ini terlambat 89 hari dari target SLA (09/02).",
      nextStageOptions: ["Klarifikasi", "Evaluasi Harga", "Laporan", "Award"],
      note: "",
      proofFileName: "",
      proofHistory: [
        { id: "UPR-001", stage: "Undang", fileName: "undangan_vendor.pdf", date: "2/1/2026" },
        { id: "UPR-002", stage: "Regis", fileName: "daftar_registrasi.xlsx", date: "5/1/2026" },
      ],
    },
    technicalEvaluation: {
      title: "Pengadaan Server Data Center",
      tenderId: "TND-000001",
      subtitle: "Pengadaan Peralatan Laboratorium",
      status: "Deadline",
      deadline: "15/1/2026",
      vendorCount: 8,
      tabs: [
        { id: "quantitative", label: "Kuantitatif" },
        { id: "qualitative", label: "Kualitatif" },
        { id: "price-negotiation", label: "Negosiasi Harga" },
      ],
      quantitativeRows: [
        { id: "Q-001", no: 1, element: "Pengalaman Perusahaan", maxScore: 55, weight: "25%" },
        { id: "Q-002", no: 2, element: "Kualifikasi Tim", maxScore: 20, weight: "20%" },
        { id: "Q-003", no: 3, element: "Metodologi Kerja", maxScore: 10, weight: "25%" },
        { id: "Q-004", no: 4, element: "Peralatan & Fasilitas", maxScore: 5, weight: "15%" },
        { id: "Q-005", no: 5, element: "Kepatuhan Dokumen", maxScore: 10, weight: "15%" },
      ],
      qualitativeRows: [
        { id: "QL-001", no: 1, element: "Pemahaman terhadap lingkup pekerjaan" },
        { id: "QL-002", no: 2, element: "Pendekatan dan metodologi" },
        { id: "QL-003", no: 3, element: "Rencana kerja dan jadwal" },
        { id: "QL-004", no: 4, element: "Kompetensi personil" },
        { id: "QL-005", no: 5, element: "Dukungan teknis dan layanan purna jual" },
      ],
      vendorColumns: [
        { id: "VC-001", label: "PT. Vendor A", score: "0.00" },
        { id: "VC-002", label: "PT. Vendor B", score: "0.00" },
        { id: "VC-003", label: "PT. Vendor C", score: "0.00" },
      ],
      priceNegotiationRows: [
        {
          id: "PN-001",
          no: 1,
          vendorName: "PT. Vendor A",
          initialPrice: "0",
          negotiatedPrice: "0",
          percentage: "0.00%",
          score: "0.0",
        },
        {
          id: "PN-002",
          no: 2,
          vendorName: "PT. Vendor B",
          initialPrice: "0",
          negotiatedPrice: "0",
          percentage: "0.00%",
          score: "0.0",
        },
        {
          id: "PN-003",
          no: 3,
          vendorName: "PT. Vendor C",
          initialPrice: "0",
          negotiatedPrice: "0",
          percentage: "0.00%",
          score: "0.0",
        },
      ],
    },
  },
};
